
import { mapGetters } from 'vuex';
import generateDefImageIcon from '~/mixins/generate-def-image-icon';

export default {
    mixins: [generateDefImageIcon],
    data() {
        return {
            contact: null,
            openItems: []
        };
    },
    async fetch() {
        if (this.contacts && this.contacts?.length) {
            this.contact = this.contacts[0];

            return;
        }

        await this.$axios
            .$get('base/contacts')
            .then(contacts => {
                if (contacts.length) {
                    this.contact = contacts[0];
                }
            })
            .catch(err => {
                console.error(err);
            });
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            footerSettings: 'footer/footerSettings',
            contacts: 'contacts/getShopsContacts',
            mainPhoneNumber: 'global/mainPhoneNumber',
            isCasaDelTabaco: 'global/getIsCasaDelTabaco',
            developer: 'footer/getDeveloper',
            mainEmail: 'global/getMainEmail',
            filteredSocialMediaLinks: 'global/getFilteredSocialMediaLinksForFooter'
        }),
        telegramSocialLink() {
            return this.globalSettings?.social_media?.find(social => social.key.slug === 'telegram') || null;
        },
        viberSocialLink() {
            return this.globalSettings?.social_media?.find(social => social.key.slug === 'viber') || null;
        },

        isFaqLinkAllow() {
            let flag = false;

            if (this.isCasaDelTabaco) flag = true;

            return flag;
        }
    },
    methods: {
        toggleItem(key) {
            if (this.openItems.includes(key)) {
                this.openItems = this.openItems.filter(e => e !== key);
            } else {
                this.openItems.push(key);
            }
        }
    }
};
